import axios from 'axios';

const API_BASE_URL = 'http://localhost:8081/api/auth'

export const registerUser = async (userData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/register`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const loginUser = async (credentials) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/login`, credentials);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getUserProfile = async (userId) => {
  try {
    const response = await axios.get(`http://localhost:8081/api/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const response = await axios.put(`http://localhost:8081/api/auth/update/${userId}`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const changePassword = async (userId, oldPassword, newPassword) => {
  try {
    const response = await axios.put(`http://localhost:8081/api/auth/change-password/${userId}`,
      {
        oldPassword,
        newPassword,
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

const API_BASE_URL2 = 'http://localhost:8081/api/feedback'

export const submitFeedback = async (feedbackData) => {
  try {
    const response = await axios.post(`${API_BASE_URL2}`, feedbackData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const fetchFeedbackReports = async () => {
  try {
    const response = await axios.get('http://localhost:8081/api/feedback');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteFeedback = async (id) => {
  try {
    const response = await axios.delete(`http://localhost:8081/api/feedback/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const sendContactMessage = async (formData) => {
  try {
    const response = await axios.post('http://localhost:8081/api/contact', formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const searchAddress = async (query, countryCode) => {
  try {
    const response = await axios.get(`http://localhost:8081/api/address/search`, {
      params: { q: query, countryCode }
    });
    return response.data;
  } catch (error) {
    console.error("Address search error:", error);
    throw error.response?.data || error.message;
  }
};

export const fetchPhysioConsultations = async (physioId) => {
  const response = await axios.get(`http://localhost:8081/api/consultations/physio/${physioId}`);
  return response.data;
};

export const searchPhysios = async ({ lat, lon, radiusKm, country, speciality }) => {
  const response = await axios.get("http://localhost:8081/api/consultations/search-physios", {
    params: { lat, lon, radiusKm, country, speciality }
  });
  return response.data;
};

/*export const searchPhysios = async (query) =>
  (await axios.get('/api/physios/search', { params: query })).data;*/

export const assignPhysio = async (physioId, patientId) =>
  (await axios.post(`/api/physios/${physioId}/assign`, { patientId })).data;

export const fetchSlots = async (physioId, weekIso) =>
  (await axios.get(`/api/physios/${physioId}/available-slots`, { params:{week:weekIso} })).data;

export const bookConsultation = async (payload) =>
  (await axios.post('/api/consultations', payload)).data;

export default axios;